module.exports = __webpack_public_path__ + "CreativeDirection22.png?f73f4007f68e849e302b99610da95cc8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection22.png
// module id = 34
// module chunks = 0